export default __webpack_public_path__ + "static/media/mediaTypeDirectMail.cafa9ea0.svg";